// extracted by mini-css-extract-plugin
export default {"modalTitle":"modal-account_modalTitle__rcCPH","modalForm":"modal-account_modalForm__nsKTR","actions":"modal-account_actions__KalXi"};